import React from "react";
var __jsx = React.createElement;
//@ts-ignore

import { useTranslation } from "@i18n";
import { twMerge } from "tailwind-merge";
import { Icon } from "@syarahtech/ui";
import Tooltip from "@componentsShared/Tailwind/Tooltip/Tooltip";
import { useLang } from "@/common/Contexts/LanguageContext";
var CarColorVariation = function CarColorVariation(_ref) {
  var colors = _ref.colors,
    currentColorName = _ref.currentColorName,
    currentColorCode = _ref.currentColorCode,
    onColorClick = _ref.onColorClick,
    _ref$showDisclaimer = _ref.showDisclaimer,
    showDisclaimer = _ref$showDisclaimer === void 0 ? false : _ref$showDisclaimer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "border-t border-solid border-neutral-10 pt-3 mt-3 font-bold"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5 text-gray-text text-xs mb-3"
  }, /*#__PURE__*/React.createElement("span", null, t("لون السيارة:", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", null, currentColorName)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end gap-3 en:justify-start",
    style: {
      direction: "ltr"
    }
  }, colors.map(function (color, idx) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      text: lang === 'ar' ? color.name_ar : color.name_en,
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: twMerge("w-4 h-4 rounded-full cursor-pointer hover:opacity-80 transition-opacity duration-200", currentColorCode === color.color_code && "border border-solid border-primary"),
      onClick: function onClick() {
        return onColorClick(color);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: twMerge("w-full h-full rounded-full border border-solid border-neutral-10"),
      style: {
        backgroundColor: color.color_code
      }
    })));
  })), showDisclaimer && /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-1 text-gray-slate text-xs mt-2 font-semibold"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--info-outline-rounded",
    width: 4,
    height: 4,
    className: "text-gray-slate mt-0.5"
  }), /*#__PURE__*/React.createElement("span", null, t("هل تحتاج إلى المزيد من الصور؟ يمكنك طلب صور إضافية عند حجز السيارة", {
    ns: "web_post_view"
  })))));
};
export default CarColorVariation;